import React from "react"

export const SuperaltsLogo = ({ className }: { className?: string }) => {
  return (
    <svg 
      viewBox="0 0 48 48" 
      className={`w-6 h-6 text-sidebar-foreground ${className}`}
      fill="currentColor"
    >
      <g transform="matrix(0.6 0 0 0.6 2 2)">
        <path d="M5.26 0L2.63 0L2.63 17.67L0 18.6L0 43.04L5.26 43.04L5.26 0Z" transform="translate(59.35, 19.39)" />
        <path d="M5.27 0L0 0L0 14.68L2.64 14.68L2.64 32.44L0 33.36L0 43.04L5.27 43.04L5.27 0Z" transform="translate(17.2, 19.39)" />
        <path d="M5.27 0L0 0L0 7.3L2.64 7.3L2.64 25.05L0 25.98L0 43.04L5.27 43.04L5.27 0Z" transform="translate(38.27, 19.39)" />
        <path d="M5.27 0L0 0L0 3.61L2.64 3.61L2.64 21.36L0 22.29L0 43.04L5.27 43.04L5.27 0Z" transform="translate(48.81, 19.39)" />
        <path d="M5.27 0L0 0L0 10.99L2.63 10.99L2.63 28.74L0 29.67L0 43.04L5.27 43.04L5.27 0Z" transform="translate(27.74, 19.39)" />
      </g>
    </svg>
  )
}